import { createApiQuery } from '@/hooks/use-api-query';
import { get } from '@/libs/http';
import type { CountryListRes } from '@/types/api/user-auth/country-list';

export const getCountryList = () => get<CountryListRes>('/user/auth/v1/countryList');

export const useGetCountryList = createApiQuery(getCountryList, () => ['countries']);
